import React, { useEffect } from 'react'
import { Route } from 'react-router-dom'
import { getRoutes } from './'
import { RoutePropsType } from './PropsType'
import { getStore } from '@/store'
import { checkConnectExpire } from '@/utils/userHelper'
import { isBackendPath } from '@/utils/utils'

const RouteWrap: React.FC<RoutePropsType> = props => {
  const { component, title, auth, ...rest } = props
  const router = getRoutes()

  useEffect(() => {
    if (title) {
      document.title = title
    }
  }, [title])

  const RouteInner = ({ component: Component, ...rest }: any) => {
    if (auth) {
      const { userStore } = getStore()
      const isBackendRoute = isBackendPath(props.name)

      if (!userStore.userConnectStatus) {
        // 未连接情况下，对登录管理后台不做权限校验
        if (!isBackendRoute) {
          router.login.pushSelf()
        }
      } else {
        checkConnectExpire().then(isExpire => {
          if (!isExpire && !isBackendRoute) {
            router.login.pushSelf()
          }
        })
      }
    }

    return <Component router={router} title={title} auth={auth} {...rest} />
  }

  return (
    <Route
      {...rest}
      render={props => <RouteInner {...props} component={component} />}
    />
  )
}

export default RouteWrap
